import { useState, useEffect } from "react";
import { GenerateGeom } from "src/managers/GenerateGeom";


export function MitPatt(props: { pattern: string, opacity?: number, size?: number }) {
   let [imgUrl, setImgUrl] = useState<string>("");
   const size = props.size ?? 20;

   useEffect(() => {
      GenerateGeom.getEveryMitPattern(props.pattern, (url) => {
         setImgUrl(url);
      });
   }, [props.pattern])

   return (
      <div style={{ width: size, height: size, backgroundColor: "white", marginLeft: props.size == null ? "2px" : 0, marginRight: props.size == null ? "0px" : 4, borderRadius: "3px", display: props.size == null ? "flex" : "inline-flex", alignItems: "center", justifyContent: "center", overflow: "hidden", padding: props.size == null ? "2px" : 0, verticalAlign: "text-bottom" }}>
         <div style={{ width: "100%", height: "100%", backgroundImage: `url(${imgUrl})`, backgroundSize: "cover", opacity: props.opacity ?? 1 }}></div>
      </div>
   )
}